import { state, color } from "../../tokens/semantic";
import { Link as RouterLink } from 'react-router-dom';

const MuiLink = {
    defaultProps: {
        underline: 'hover',
        tabIndex: 0,
        component: RouterLink,
    },
    styleOverrides: {
        root: {
            color: color.text.link,
            '&:hover': {
                color: color.text.linkHover,
                cursor: 'pointer',
            },
            '&:active': {
                color: color.text.linkActive,
            },
            '&&:focus-visible': {
                outline: `${state.outline.weight.focus.md} solid ${state.outline.color.focus}`,
                outlineOffset: state.outline.offset.focus.md,
                borderRadius: state.outline.radius.focus,
            }
        }
    }
}

export default MuiLink;